const clamp = (v) => Math.max(0, Math.min(255, Math.round(v)));

export function hexToRgb(hex) {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
  if (!m) return null;
  const n = parseInt(m[1], 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

const toHex = (rgb) => `#${rgb.map((v) => clamp(v).toString(16).padStart(2, "0")).join("")}`;

export function hexToHsl(hex) {
  const [r, g, b] = hexToRgb(hex).map((v) => v / 255);
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h = 0;
  let s = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
    h *= 60;
  }
  return `${Math.round(h)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

export const mix = (hex, withHex, amount) => {
  const a = hexToRgb(hex);
  const b = hexToRgb(withHex);
  return toHex(a.map((v, i) => v + (b[i] - v) * amount));
};

const lum = (hex) => {
  const [r, g, b] = hexToRgb(hex).map((v) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

export function contrast(a, b) {
  const [x, y] = [lum(a), lum(b)].sort((m, n) => n - m);
  return (x + 0.05) / (y + 0.05);
}

export const readableOn = (hex) => (contrast("#FFFFFF", hex) >= contrast("#0B1220", hex) ? "#FFFFFF" : "#0B1220");

export function applyColourTokens({ brand_colour: brand, action_colour: action }) {
  const root = document.documentElement.style;
  if (hexToRgb(brand)) {
    root.setProperty("--brand", brand);
    root.setProperty("--brand-hsl", hexToHsl(brand));
    root.setProperty("--brand-soft", `${brand}1F`);
    root.setProperty("--brand-strong", mix(brand, "#000000", 0.35));
    root.setProperty("--brand-deep", mix(brand, "#000000", 0.6));
  }
  if (hexToRgb(action)) {
    root.setProperty("--action", hexToHsl(action));
    root.setProperty("--action-foreground", hexToHsl(readableOn(action)));
  }
}
